import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from 'src/app/shared/confirmation-dialog/confirmation-dialog.component';
import { GameStatisticsService } from 'src/app/shared/game-statistics.service';
import { GameStatisticsViewViewModel, GameStatisticsGroupViewModel, GameStatisticsProfileViewModel } from 'src/app/stats/models/statistics.model';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

import { MatCard, MatCardHeader, MatCardTitle, MatCardContent, MatCardActions } from '@angular/material/card';
import { RouterLink } from '@angular/router';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

@Component({
    selector: 'app-config-statistics-profiles',
    templateUrl: './config-statistics-profiles.component.html',
    styleUrls: ['./config-statistics-profiles.component.css'],
    imports: [MatButton, MatIcon, MatCard, MatCardHeader, MatCardTitle, MatCardContent, MatCardActions, RouterLink]
})
export class ConfigStatisticsProfilesComponent implements OnInit {

  profiles: GameStatisticsProfileViewModel[];

  constructor(public statsService: GameStatisticsService, public dialog: MatDialog) {

   

    this.loadData();

  }

  ngOnInit() {
  }

  
  loadData(){
    this.statsService.getAllProfiles().subscribe(data=>{
      
      this.profiles = data as GameStatisticsProfileViewModel[] ;
    });
    
  }

  confirmDeleteProfile(profile){

    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '350px',
      data: 'Do you really want to delete the profile ' + profile.Name + '?'
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result){
        console.log(profile);
        this.statsService.deleteProfile(profile.GameStatisticsProfileId).subscribe(res=>{
          console.log(res);
          if(res)
            this.loadData();

        });
        console.log('deleting');
      }      
      
      //this.animal = result;
    });

  }

  openAddDialog(): void {
    const dialogRef = this.dialog.open(ConfigStatisticsNewprofileDialog, {
      width: '250px',
      data: {name: ''}
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log(result);
      if(result.length>0)
        this.statsService.insertProfile(result).subscribe(res=>{
          this.loadData();
        });
      
    });
  }

}
export interface DialogData { 
  name: string;
}


@Component({
    selector: 'config-statistics-newprofile-dialog',
    templateUrl: 'config-statistics-newprofile-dialog.html',
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatFormField, MatLabel, MatInput, ReactiveFormsModule, FormsModule, MatDialogActions, MatButton, MatDialogClose]
})
export class ConfigStatisticsNewprofileDialog {

  constructor(
    public dialogRef: MatDialogRef<ConfigStatisticsNewprofileDialog>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) {}

  onNoClick(): void {
    this.dialogRef.close("");
  }

}
